import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import BalanceComp  from "./Component/BalanceComp"

const Balance =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <BalanceComp />
        </div>
        <Footer />
        </>
    )
}

export default Balance